import styled from 'styled-components';

export const StyledSetupWizard = styled.div``;
